export enum QuoteSettingType {
  SE = 'SE',
  OP = 'OP',
  IN = 'IN',
  MF = 'MF'
}
